import React from "react";
import { List } from "@material-ui/core";
import DarkBar from "../DarkBar";
import ContractItem from "./ContractItem";

const compPhaseHelper = {
  WAITING_SIGN: 0,
  WAITING_APORT: 1,
  WAITING_VALIDATION: 2,
  VALIDATING: 3,
  EXECUTING: 4,
  WAITING_WITHDRAW: 5,
  REDEEMED: 6,
  CANCELED: 7,
};

const compPhase = (c1, c2) => (c1.phase === c2.phase ? null : compPhaseHelper[c1.phase] - compPhaseHelper[c2.phase]);
const compId = (c1, c2) => c2.id - c1.id;

const adjustPhase = (c) => (c.phase !== "WAITING_APORT" ? c.phase : c.deposits.length > 0 ? "WAITING_VALIDATION" : c.phase);
const sortContracts = (contracts) => contracts.map((c) => ({ ...c, phase: adjustPhase(c) })).sort((c1, c2) => compPhase(c1, c2) ?? compId(c1, c2));

const groupContractsByPhase = (contracts) => {
  const sortedContracts = sortContracts(contracts);
  const groups = [];
  let currentPhase = null;

  for (const contract of sortedContracts) {
    if (contract.phase !== currentPhase) {
      groups.push({
        phase: contract.phase,
        contracts: [contract],
      });
      currentPhase = contract.phase;
    } else {
      groups[groups.length - 1].contracts.push(contract);
    }
  }

  return groups;
};

const ContractsList = ({ contracts, currentUser }) => {
  const groupedContracts = React.useMemo(() => groupContractsByPhase(contracts), [contracts]);

  return (
    <List>
      {groupedContracts.map(({ phase, contracts }) => (
        <React.Fragment key={phase}>
          <DarkBar text={`app.enuns.${phase}`} />
          {contracts.map((contract) => (
            <ContractItem
              key={contract.id}
              contract={contract}
              currentUser={currentUser}
            />
          ))}
        </React.Fragment>
      ))}
    </List>
  );
};

export default ContractsList;
